<template lang="html">
     <div class="inner-page">
        <Header>我的</Header>
        <div class="scroll-list" :style="'height:' + scrollH + 'px'">
              <div class="user-infos">
                   <div class="user-img">
                        <img :src="imageUrl" alt="">
                   </div>
                   <div class="user-content">
                        <div v-if="userID">
                            <div class="user-name">{{nickname}}</div>
                            <div class="user-text">所属机构：{{organization||'/'}}</div>
                            <div class="user-text">有效期限：{{memberEnd||'/'}}</div>
                        </div>
                        <div v-else class="unLogin">
                            <span @click="goLogin">登录</span>
                        </div>
                   </div>
              </div>

              <div class="nav-list">
                   <div class="nav-item item-first" @click="goInner(1)">
                        <van-icon class="icon" class-prefix="iconfont" name="collected" />
                        <div class="item-name">我的收藏</div>
                        <van-icon class="icon" class-prefix="iconfont" name="more" />
                   </div>
                   <div class="sub-list">
                       <div class="nav-item" @click="goInner(2)">
                            <van-icon class="icon" class-prefix="iconfont" name="suggest" />
                            <div class="item-name">意见反馈</div>
                            <van-icon class="icon" class-prefix="iconfont" name="more" />
                       </div>
                       <div class="nav-item" @click="goInner(3)">
                            <van-icon class="icon" class-prefix="iconfont" name="about" />
                            <div class="item-name">关于音网</div>
                            <van-icon class="icon" class-prefix="iconfont" name="more" />
                       </div>
                   </div>
              </div>

              <Footer />
        </div>


     </div>
</template>

<script>
import vEmits from "@/utils/vEmits";
// import { mapState } from 'vuex';
import storage from 'good-storage';
export default {
     // computed:{
     //     ...mapState('user',{
     //          userId:'userId',
     //          imageUrl:'imageUrl',
     //          nickname:'nickname',
     //          realName:'realName',
     //          organization:'organization',
     //          memberEnd:'memberEnd'
     //     })
     // },
     data(){
          return{
              isLogin:false,
              scrollH:'',
              userID:'',
              imageUrl:'',
              nickname:'',
              organization:'',
              memberEnd:''
          }
     },
     methods:{
          goInner:function(type){
              let urls = ['collect','suggest','about'];

              if(type < 3 && !this.userID){
                  vEmits.$emit('show','请先登录');
              }else{
                  this.push(urls[type - 1]);
              }

          },
          goLogin:function(){
              this.push('login');
          }
     },
        mounted(){
            if(storage.get("userInfo")){
                this.userID = storage.get("userInfo").userId;
                this.imageUrl = storage.get("userInfo").imageUrl;
                this.nickname = storage.get("userInfo").nickname;
                this.organization = storage.get("userInfo").organization;
                this.memberEnd = storage.get("userInfo").memberEnd;

                window.console.log(storage.get("userInfo"))

            }
        },
     created:function(){
          this.scrollH = document.documentElement.clientHeight - 102;

     }
}
</script>

<style lang="css" scoped>

.inner-page{
    position: absolute;
    left: 0px;
    top: 0px;
    height: 100%;
}

.scroll-list{
    overflow-y: scroll;
}

/* 个人信息 */

.user-infos{
    display: flex;
    background: white;
    padding: 18px 10px;
    align-items: center;
}

.user-infos .user-img{
    height: 75px;
    width: 75px;
    border-radius: 75px;
    background: #efefef;
}

.user-infos .user-img img{
    height: 75px;
    width: 75px;
    border-radius: 75px;
}

.user-infos .user-content{
    margin-left: 10px;
}

.user-infos .user-text{
    font-size: 14px;
    color: #999999;
    margin-top: 3px;
}

/* 导航列表 */

.nav-list .nav-item{
    display: flex;
    height: 55px;
    background: white;
    align-items: center;
    border-bottom: 1px solid #efefef;
}

.nav-list .nav-item .icon:first-child{
    font-size: 24px;
    color: #999999;
    margin-left: 10px;
}

.nav-list .nav-item .icon:last-child{
    font-size: 26px;
    color: #999999;
}

.nav-list .nav-item .item-name{
    flex-grow: 1;
    margin-left: 18px;
}

.nav-list .sub-list{
    background: white;
    padding-bottom: 30px;
}

.nav-list .sub-list .nav-item{
    margin-left: 10px;
}

.nav-list .sub-list .nav-item .icon:first-child{
    margin-left: 0px;
    font-size: 24px;
}

</style>
